module.exports = __webpack_public_path__ + "img/Left_six.281df291.svg";